import { columnParams } from "app/shared/models/types/types";

export const licensesColumnsParams: columnParams[] = [
    {
        name: 'clientName',
        title: 'repository.licenses.list.clientName',
        editable: true,
        visible: true,
    },
    {
        name: 'startDate',
        title: 'repository.licenses.list.startDate',
        editable: true,
        visible: true,
    },
    {
        name: 'endDate',
        title: 'repository.licenses.list.endDate',
        editable: true,
        visible: true,
    },
    {
        name: 'monthlyPrice',
        title: 'repository.licenses.list.monthlyPrice',
        editable: true,
        visible: true,
    },
    {
        name: 'pricePerExtraOrder',
        title: 'repository.licenses.list.pricePerExtraOrder',
        editable: true,
        visible: true,
    },
    {
        name: 'maxOrdersPerMonth',
        title: 'repository.licenses.list.maxOrdersPerMonth',
        editable: true,
        visible: true,
    },
    {
        name: 'comment',
        title: 'repository.licenses.list.comment',
        editable: true,
        visible: true,
    },
    {
        name: 'actions',
        title: 'repository.licenses.list.actions',
        editable: false,
        visible: true,
    }
];